module.exports = __webpack_public_path__ + "img/ceo.56b26231.svg";